var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVagrant({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1159cc",
    d: "M122.5 23.9V12.82L95.91 28.3v9.34l-21.28 45.9-10.64 7.33v33.61l22.81-13.15 35.7-87.43zM63.99 66.94L48.04 29.71V19.19l-.11-.06-15.84 9.17v9.34l21.27 47.91 10.63-5.25V66.94z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#127eff",
    d: "M106.55 3.52L79.97 19.09l-.02-.01V29.71L63.99 66.94v12.45l-10.63 6.16-21.27-47.91v-9.36l15.96-9.19-26.6-15.57-15.95 9.3v11.42l35.9 87.2 22.59 13.04V91.72l10.64-6.17-.13-.08 21.41-47.83v-9.36l26.59-15.46-15.95-9.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVagrant);
export default __webpack_public_path__ + "static/media/vagrant.88a97090d5000c71dfb7a27147db2614.svg";
export { ForwardRef as ReactComponent };